import React, { useContext, useRef } from 'react';
import { useForm } from 'react-hook-form';
import emailjs from '@emailjs/browser';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { DarkModeContext } from '../../App';

const Contact = () => {
    const { register, formState: { errors }, handleSubmit, reset } = useForm();
    const form = useRef()
    const [darkMode, setDarkMode] = useContext(DarkModeContext);

    const sendEmail = (data) => {
        // console.log(data)
        // let emailData = {
        //     email: data.email,
        //     message: data.message,
        //     name: data.name
        // }
        // console.log(emailData);
        emailjs.sendForm('userMailForHn', 'userMailTemplateForHn', form.current, 'Xgm-zyN1nm90Z0_bX')
            .then((res) => {
                console.log(res)
                if(res.status === 200) {
                    toast.success("Message sent successfully", {id: 'success'})
                    reset()
                }
            }, (err) => {
                toast.error("Message not sent", {id: 'error'})
            })
    }

    return (
        <section>
            <form ref={form} onSubmit={handleSubmit(sendEmail)}>
                <section className=" body-font relative md:px-5">
                    <div className="">
                        <div className="lg:w-full w-10/12 mx-auto border px-5 py-12 md:px-16 shadow-md  rounded">
                            {/* <h2 className={`${darkMode ? "text-white" : "text-black"}  uppercase text-3xl font-bold text-center`}> */}
                            <h2 className={` ${darkMode && "text-white"} uppercase text-3xl mb-2 font-bold text-center`}>
                                Contact Us
                            </h2>
                            <div className="flex justify-center mb-10">
                                <div className=" rounded-md w-40 h-1 bg-[#18a42b]"></div>
                                <div className=" rounded-md w-4 h-1 mx-2 bg-[#0d9445]"></div>
                                <div className=" rounded-md w-2 h-1 bg-[#0d9445]"></div>
                            </div>
                            <div className="flex flex-wrap -m-2">
                                <div className="p-2  w-full">
                                    <div className="relative">
                                        {/* <label htmlFor="name" className={`${darkMode ? "text-white" : "text-black"}  leading-7 text-sm  font-medium`}>Name</label> */}
                                        
                                        <input 
                                        placeholder='Name'
                                        {...register('name', {
                                            required: {
                                                value: true,
                                                message: 'Name is required'
                                            },
                                            
                                            minLength: {
                                                value: 3,
                                                message: 'Name must be at least 3 characters'
                                            }
                                        })} type="text" id="name" name="name" className="w-full bg-opacity-50 rounded border border-gray-300 focus:border-indigo-500 focus:bg-white focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out" />
                                    </div>
                                    <label>
                                        {errors.name?.type === 'required' && <p className='text-red-600 text-sm font-semibold'>{errors.name.message}</p>}
                                        {errors.name?.type === 'minLength' && <p className='text-red-600 text-sm font-semibold'>{errors.name.message}</p>}
                                    </label>
                                </div>
                                <div className="p-2 w-full">
                                    <div className="relative">
                                        <input 
                                        placeholder='Email'
                                        {...register('email', {
                                            required: {
                                                value: true,
                                                message: 'Email is required'
                                            },
                                            pattern: {
                                                value: /[a-z0-9]+@[a-z]+\.[a-z]{2,3}/,
                                                message: 'Invalid email address'
                                            }
                                        })} type="email" id="email" name="email" className="w-full bg-opacity-50 rounded border border-gray-300 focus:border-indigo-500 focus:bg-white focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out" />
                                    </div>
                                    <label>
                                        {errors.email?.type === 'required' && <p className='text-red-600 text-sm font-semibold'>{errors.email.message}</p>}
                                        {errors.email?.type === 'pattern' && <p className='text-red-600 text-sm font-semibold'>{errors.email.message}</p>}
                                    </label>
                                </div>
                                <div className="p-2 w-full">
                                    <div className="relative">
                                        <textarea 
                                        placeholder='Message'
                                        {...register('message', {
                                            required: {
                                                value: true,
                                                message: 'Message is required'
                                            },
                                            minLength: {
                                                value: 10,
                                                message: 'Message must be at least 10 characters'
                                            }
                                        })} id="message" name="message" className="w-full bg-opacity-50 rounded border border-gray-300 focus:border-indigo-500 focus:bg-white focus:ring-2 focus:ring-indigo-200 h-32 text-base outline-none text-gray-700 py-1 px-3 resize-none leading-6 transition-colors duration-200 ease-in-out"></textarea>
                                    </div>
                                    <label>
                                        {errors.message?.type === 'required' && <p className='text-red-600 text-sm font-semibold'>{errors.message.message}</p>}
                                        {errors.message?.type === 'minLength' && <p className='text-red-600 text-sm font-semibold'>{errors.message.message}</p>}
                                    </label>
                                </div>
                                <div className="p-2 pt-6 w-full">
                                    <button type='submit' className=" btn btn-sm lg:px-8 px-4 ml-auto rounded-full text-white btn-secondary tracking-widest text-sm font-bold">Send <FontAwesomeIcon className='ml-2' icon={faEnvelope}></FontAwesomeIcon> </button>
                                    <p className={`inline-block lg:ml-8 ${darkMode ? "text-gray-300 pt-2 text-xs" : " "}`}>* I promise the confidentiality of your personal information</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </form>
        </section>
    );
};

export default Contact;